
import { fillSeo } from 'razlet-sulu-sdk/lib/utils/helpers';
import sulu from 'razlet-sulu-sdk/lib/mixins/sulu';
import globalEvents from '~/mixins/global-events';

export default {
  name: 'refund-page',
  mixins: [sulu, globalEvents],
  data () {
    return {
      isAffiliatorLoaded: false,
      isAffiliatorDefined: false,
      isMounted: false,
    };
  },
  mounted () {
    this.isMounted = true;
    window.customElements.whenDefined('razlet-affiliator').then(() => {
      this.isAffiliatorDefined = true;
      this.isAffiliatorLoaded = true;
    });
  },
  head () {
    return {
      ...fillSeo(this, this.result.seo),
      script: [
        { 
          skip: !this.isMounted || this.isAffiliatorDefined,
          hid: 'avia',
          vmid: 'avia', 
          type: 'text/javascript',
          // type: 'text/partytown',
          src: `${process.env.affURL}/manas/aviaHome/main.js`,
          async: true,
          callback: () => { this.isAffiliatorLoaded = true; },
        },
      ],
    };
  },
};
